import { getToken } from "./authService";
import { toast } from "./toast.jsx";

const BACKEND_URL = import.meta.env.VITE_BACKEND_URL;

function buildAuthHeaders(extraHeaders = {}) {
  const token = getToken();
  const headers = { ...extraHeaders };
  if (token) headers.Authorization = `Bearer ${token}`;
  return headers;
}

function notifySessionExpired(response) {
  if (!response) return;
  if (response.status === 401) {
    window.dispatchEvent(new CustomEvent("auth:session-expired"));
  }
}

function notifyRateLimited(response) {
  if (!response) return;
  if (response.status === 429) {
    toast.error("Too many requests, please wait a moment.");
  }
}

async function request(path, options = {}) {
  const response = await fetch(`${BACKEND_URL}${path}`, options);
  notifySessionExpired(response);
  notifyRateLimited(response);
  return response;
}

export async function apiGet(path) {
  return request(path, {
    headers: buildAuthHeaders(),
  });
}

export async function apiPublicGet(path) {
  return request(path, {});
}

export async function apiPost(path, body) {
  return request(path, {
    method: "POST",
    headers: buildAuthHeaders({ "Content-Type": "application/json" }),
    body: JSON.stringify(body),
  });
}

export async function apiPublicPost(path, body) {
  return request(path, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
}

export async function apiDelete(path) {
  return request(path, {
    method: "DELETE",
    headers: buildAuthHeaders(),
  });
}

export async function apiPut(path, body) {
  return request(path, {
    method: "PUT",
    headers: buildAuthHeaders({ "Content-Type": "application/json" }),
    body: JSON.stringify(body),
  });
}

// Uploads a raw file body (not JSON, not multipart) — e.g. an agent release zip.
export async function apiUploadFile(path, file) {
  return request(path, {
    method: "POST",
    headers: buildAuthHeaders({ "Content-Type": file.type || "application/octet-stream" }),
    body: file,
  });
}
